import React from 'react'
import { useNavigate } from "react-router-dom";


function PatientAppointments() {

    const navigate = useNavigate();
    return (
        <div className="container-fluid">
            <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

                <div className="d-flex">
                    <h4 className='m-0 p-3'>
                        Appointments
                    </h4>

                </div>

                <div className='d-flex align-items-center justify-content-end gap-3'>
                    <div className='d-flex align-items-center gap-3'>
                        <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                        <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                            <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row mb-3">

                    <div className="col-12">
                        <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <span>
                                    Upcoming Appointments
                                </span>
                                <button className='div-ButtonGreen' style={{ color: '#fff' }} onClick={() => navigate("/AddAppointment")}>+ Add Appointment</button>
                            </div>

                            <hr style={{ borderTop: "grey 1px dashed" }} />




                        </div>


                    </div>
                </div>

                <div className="row mt-4">

                    <div className="col-12">
                        <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                            <div className="d-flex justify-content-between">
                                <span>
                                    Treatment History
                                </span>

                                <div className="d-flex align-items-center gap-2 text-primary">
                                    <span>
                                        view all
                                    </span>
                                    <i class="fa-solid fa-chevron-right"></i>
                                </div>
                            </div>

                            <hr style={{ borderTop: "grey 1px dashed" }} />



                            <div className="d-flex flex-column" style={{ height: "15rem", overflowX: "scroll" }}>
                                <div className="">
                                    <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                        <div className="d-flex align-items-center gap-3">
                                            <img src="/Images/Group9.png" alt="" />
                                            <span className="d-flex flex-column align-items-start">
                                                <span className="m-1">Diabetes</span>
                                                <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                            </span>
                                        </div>

                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Shekar</span></span>
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                        </span>
                                    </span>
                                </div>

                                <div className="">
                                    <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                        <div className="d-flex align-items-center gap-3">
                                            <img src="/Images/Group9.png" alt="" />
                                            <span className="d-flex flex-column align-items-start">
                                                <span className="m-1">Diabetes</span>
                                                <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                            </span>
                                        </div>

                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Sanjay</span></span>
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                        </span>
                                    </span>
                                </div>

                                <div className="">
                                    <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                        <div className="d-flex align-items-center gap-3">
                                            <img src="/Images/Group9.png" alt="" />
                                            <span className="d-flex flex-column align-items-start">
                                                <span className="m-1">Diabetes</span>
                                                <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                            </span>
                                        </div>

                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Hemalatha</span></span>
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                        </span>
                                    </span>
                                </div>

                                <div className="">
                                    <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                        <div className="d-flex align-items-center gap-3">
                                            <img src="/Images/Group9.png" alt="" />
                                            <span className="d-flex flex-column align-items-start">
                                                <span className="m-1">Diabetes</span>
                                                <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                            </span>
                                        </div>

                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. narendra</span></span>
                                            <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                        </span>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>

            </div>
        </div>





    )
}

export default PatientAppointments